import moment from 'moment'
import numeral from 'numeral'
import _ from 'lodash'
import { constants } from '@adc/ui-adc'

const isNumeric = n => !isNaN(parseFloat(n)) && isFinite(n)
const formatNumber = val =>
  isNumeric(val) ? parseFloat(val).toLocaleString() : val
const fullForm = val => (val ? val.replace(/SFR/, 'Single Family') : val)
const formatPropertyType = (value = '') =>
  fullForm(value ? value.split('_').map(_.capitalize).join(' ') : '')
const formatMoney = val => (isNumeric(val) ? `$${formatNumber(val)}` : val)
const formatDate = val => moment(val).format(constants.statics.UI_DATE_FORMAT)
const formatDateMonthNameDayYear = val => {
  if (_.isNil(val)) return 'TBD'
  return moment(val).format('MMM DD, YYYY')
}
const formatDateDetailed = val =>
  moment(val, 'YYYY-MM-DD h:mm a').format('dddd, MMM D, YYYY | h:mma')

// Formats a ten digit phone number: '1234567890' => '(123) 456-7890'
const formatPhoneNumber = value => {
  const digits = (value + '').replace(/[^\d]/g, '')

  // NOTE: This can cause weird results if QA randomized these numbers because it's possible to get numbers with
  // a leading 0, in which case `parseInt` will strip it from the result and cause this condition to fail and the
  // formatting not to be added
  if (digits.length === 10 && digits === '' + parseInt(digits, 10)) {
    return (
      '(' +
      digits.slice(0, 3) +
      ') ' +
      digits.slice(3, 6) +
      '-' +
      digits.slice(6)
    )
  } else {
    return value
  }
}

/**
 * numeral provides an interface for setting a global zero format and a global null format,
 * but it does not provide an interface for setting a one-time zero format or null format
 * (this features has been requested, though: https://github.com/adamwdraper/Numeral-js/issues/257).
 * This utility provides such an interface.
 */
const formatMoneyWithNumeral = (val, placeholder, format) => {
  const originalZeroFormat = numeral(0).format(format)
  const originalNullFormat = numeral(null).format(format)
  if (typeof placeholder === 'string') {
    numeral.zeroFormat(placeholder)
    numeral.nullFormat(placeholder)
  }
  const result = numeral(val).format(format)
  numeral.zeroFormat(originalZeroFormat)
  numeral.nullFormat(originalNullFormat)
  return result
}

const NUMERAL_FORMAT_WITH_CENTS = '$0,0.00'

const formatMoneyWithCents = (val, placeholder) => {
  return formatMoneyWithNumeral(val, placeholder, NUMERAL_FORMAT_WITH_CENTS)
}

const formatMoneyWithCentsExceptZero = (val, placeholder) => {
  return Number.isInteger(val)
    ? formatMoneyWithNumeral(val, placeholder)
    : formatMoneyWithCents(val, placeholder)
}

export {
  formatNumber,
  formatMoney,
  formatMoneyWithNumeral,
  formatMoneyWithCents,
  formatMoneyWithCentsExceptZero,
  formatDate,
  formatDateMonthNameDayYear,
  formatDateDetailed,
  formatPhoneNumber,
  fullForm,
  formatPropertyType,
}
